import React from "react"
import { ThemeProvider } from "styled-components"

import componentThemeExtension from "utils/componentThemeExtension"
import {
  PodcastRailHeader,
  PodcastContainer,
  PodcastCardContainer,
  PodcastRailCard,
  PodcastGridWrapper,
} from "./styles"

const PodcastGrid = ({ items, title, backgroundColor, onTop, theme }) => {
  if (!items || !items.length) {
    return null
  }

  return (
    <ThemeProvider theme={componentThemeExtension(backgroundColor, false, onTop, theme || null)}>
      <PodcastGridWrapper>
        <PodcastRailHeader title={title} />
        <PodcastContainer>
          {items.map((item, i) => (
            <PodcastCardContainer key={item.id}>
              <PodcastRailCard component={item} />
            </PodcastCardContainer>
          ))}
        </PodcastContainer>
      </PodcastGridWrapper>
    </ThemeProvider>
  )
}

export default PodcastGrid
